import React, { useState } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from 'reactstrap';

//import images
import cafe from "../../assets/images/brands/Cafe.png";
import collect from "../../assets/images/brands/collect.png";
import rides from "../../assets/images/brands/rides.png";
import pets from "../../assets/images/brands/Pets.png";
import { Link } from 'react-router-dom';

const WebAppsDropdown = () => {
    const [isWebAppDropdown, setIsWebAppDropdown] = useState(false);
    const toggleWebAppDropdown = () => {
        setIsWebAppDropdown(!isWebAppDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isWebAppDropdown} toggle={toggleWebAppDropdown} className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle tag="button" type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                    <i className='bx bx-category-alt fs-22'></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg p-0 dropdown-menu-end">
                    <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                        <Row className="align-items-center">
                            <Col>
                                <h6 className="m-0 fw-semibold fs-15"> My Business </h6>
                            </Col>
                            <div className="col-auto">
                                <Link to="#" className="btn btn-sm btn-soft-info"> View All Business
                                    <i className="ri-arrow-right-s-line align-middle"></i></Link>
                            </div>
                        </Row>
                    </div>

                    <div className="p-2">
                        <div className="row g-0">
                            <Col> <Link className="dropdown-icon-item" to={"/product-list?category=collectbies"}>
                                    <img src={collect} alt="bitbucket" />
                                    <span>Seed Nations Collectbiles</span>
                                </Link>
                            </Col>
                            <Col>
                                <Link className="dropdown-icon-item"  >
                                    <img src={cafe} alt="Github" />
                                    <span>Seed Café</span>
                                </Link>
                            </Col>
                            
                        </div>

                        <div className="row g-0">
                            <Col>
                                <Link className="dropdown-icon-item">
                                    <img src={rides} alt="dribbble" />
                                    <span>Alient Rides</span>
                                </Link>
                            </Col>
                            <Col>
                                <Link className="dropdown-icon-item" >
                                    <img src={pets} alt="dropbox" />
                                    <span>Seed Pets</span>
                                </Link>
                            </Col>
                        </div>
                    </div>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default WebAppsDropdown;